import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const ChartShape = z.object({
  _id: z.any().optional(),
  name: z.string(),
  order: z.number().optional(),
  chartId: z.string(),
  filterByCreatedAt: z.boolean().optional(),
  forSupervisorOnly: z.boolean().optional(),
  declarants: z.array(z.any()).optional(),
  isChart: z.boolean().optional(),
  createdAt: z.union([z.string(), z.date()]).optional(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
});

export const chartContract = c.router({
  auth: {
    method: 'GET',
    path: '/chart/auth',
    responses: {
      200: z.object({ token: z.string(), chartsBaseUrl: z.string() }),
    },
  },
  retrieveCharts: {
    method: 'GET',
    path: '/chart/retrieve-charts/:asAdmin?',
    pathParams: z.object({ asAdmin: z.string().optional() }),
    responses: {
      200: z.object({ data: z.array(ChartShape) }),
    },
  },
  retrieveReports: {
    method: 'GET',
    path: '/chart/retrieve-reports/:asAdmin?',
    pathParams: z.object({ asAdmin: z.string().optional() }),
    responses: {
      200: z.object({ data: z.array(ChartShape) }),
    },
  },
  retrieveChartsData: {
    method: 'GET',
    path: '/chart',
    query: z.object({ criteria: z.string().optional() }),
    responses: {
      200: z.object({ data: z.object({ charts: z.array(ChartShape), totalItems: z.number() }) }),
    },
  },
  createChart: {
    method: 'POST',
    path: '/chart/create',
    body: z.object({
      name: z.string(),
      chartId: z.string(),
      order: z.number().optional(),
      isChart: z.boolean().optional(),
      filterByCreatedAt: z.boolean().optional(),
      forSupervisorOnly: z.boolean().optional(),
      declarants: z.array(z.any()).optional(),
    }),
    responses: {
      201: z.object({ data: ChartShape, message: z.string() }),
    },
  },
  editChart: {
    method: 'PATCH',
    path: '/chart/edit/:id',
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      name: z.string().optional(),
      chartId: z.string().optional(),
      order: z.number().optional(),
      isChart: z.boolean().optional(),
      filterByCreatedAt: z.boolean().optional(),
      forSupervisorOnly: z.boolean().optional(),
      declarants: z.array(z.any()).optional(),
    }),
    responses: {
      200: z.object({ data: ChartShape, message: z.string() }),
    },
  },
  deleteChart: {
    method: 'DELETE',
    path: '/chart/:id',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
});
